<input
    class="c-input { error ? 'c-input--error' : '' } { touched ? 'c-input--touched' : '' }"
    id="{ id }"
    type="email"
    {value}
    {required}
    on:change="fire('change', { value: this.value })"
    on:blur="fire('blur')"
/>